import * as Crypto from 'expo-crypto';

export function uid(prefix = '') {
  const id = Crypto.randomUUID();
  return prefix ? `${prefix}-${id}` : id;
}
